import { Store } from 'redux'

let store: Store

export const registerStore = (newStore: Store) => {
  store = newStore
}

export const getStore = () => store
